import './style.css';
import { App } from './app.js';

function required<T extends Element>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing #${id} in index.html`);
  return el as unknown as T;
}

const canvas = required<HTMLCanvasElement>('scene');
const hud = required<HTMLElement>('hud');
const lobby = required<HTMLElement>('lobby');
const toasts = required<HTMLElement>('toasts');

new App(canvas, hud, lobby, toasts);
